import {React, observer, classNames, Popover2} from '@api'
import {Button, Card, CardContent} from '@material-ui/core'
import {MoreVert} from '@material-ui/icons'
import {useChangeLogSingleItemStore} from '@modules'
import {ModalIcon, SeasonIcon, SidebarIcon, WorkspaceIcon} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './ChangeLogSingleItemMoreOptions.css'

/// region Components

interface MyProps {
  className?: string
}

const ChangeLogPopoverContent = observer<{}>(function ChangeLogPopoverContent() {
  const {onClickItemName, onClickOpenInSidebar, onClickOpenWorkspace, onClickMoveToSeason, workspace: {catalog: {catalogItemName}}} = useChangeLogSingleItemStore()
  return (
    <Card elevation={0} className={css.popover} data-type={'popover-card-content'}>
      <CardContent data-type={'popover-content'}>
        <Button onClick={onClickOpenInSidebar} startIcon={<SidebarIcon/>}>Open in Sidebar</Button>
        <Button onClick={onClickItemName} startIcon={<ModalIcon/>}>Open in Modal</Button>
        <Button onClick={onClickOpenWorkspace} startIcon={<WorkspaceIcon/>}>{`Open in ${catalogItemName ?? ''} Workspace`}</Button>
        <Button onClick={onClickMoveToSeason} startIcon={<SeasonIcon/>}>Go To Season</Button>
      </CardContent>
    </Card>
  )
})

export const ChangeLogSingleItemMoreOptions = observer<MyProps>(function ChangeLogSingleItemMoreOptions({className}) {
  return (
    <div className={classNames(css.root, className)}>
      <Popover2
        interactionKind={'click'}
        usePortal
        lazy
        minimal
        content={<ChangeLogPopoverContent/>}
      ><PrimaryIconButton icon={<MoreVert/>} data-button-type={'more-options'}/></Popover2>
    </div>
  )
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogSingleItemMoreOptions.tsx